module.exports = __webpack_public_path__ + "static/8import-bc105edea66e4b6847404008cf80eeda.png";